import { useMemo } from 'react';
import { ComplexStatus, ComplexStatusColor } from 'src/constants/complexStatus';

export const useComplexStatus = (complexStatus: ComplexStatus | undefined) => {
  const complexStatusOptions = useMemo(() => {
    return Object.keys(ComplexStatus).map((item) => ({
      label: item.toLowerCase(),
      value: item,
    }));
  }, [ComplexStatus]);

  const currentComplexStatus = useMemo(() => ({
    label: complexStatus ? complexStatus.toLowerCase() : ComplexStatus.SETUP.toLowerCase(),
    value: complexStatus || ComplexStatus.SETUP,
  }), [complexStatus]);

  const getComplexStatusColor = useMemo(() => (complexStatus ? ComplexStatusColor[complexStatus] : undefined), [complexStatus, ComplexStatusColor]);

  return {
    complexStatusOptions,
    currentComplexStatus,
    getComplexStatusColor,
  };
};
